import { AccordionSummary, Box, Typography } from '@mui/material';
import React from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/material/styles';

import { BudgetSections } from 'business/constants';
import ConditionnalZoomIconButton from 'components/ConditionnalZoomIconButton';
import { useFullScreen } from 'contexts/FullScreenContext';
import { useTranslation } from 'react-i18next';
import { getSectionLabel } from 'routes/BudgetModule/components/BudgetOverview/AllProjections/Components/helpers';

type Props = {
    section: BudgetSections | null;
    isExpanded: boolean;
};

const StyTitle = styled(Typography, {
    name: 'StyTitle',
})(({ theme }) => ({
    color: theme.palette.primary.main,
}));

const StyAccordionSummary = styled(AccordionSummary, {
    name: 'StyAccordionSummary',
})({
    width: '100%',
});

const StyProjectionDafHeader = styled(Box, {
    name: 'StyProjectionDafHeader',
})({
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
});

const ProjectionDafHeader = ({
    section,
    isExpanded,
}: Props): React.ReactElement => {
    const { isFullScreen } = useFullScreen();
    const { t } = useTranslation();
    const title = (
        <StyTitle variant="h5" sx={{ ml: isFullScreen ? '1rem' : 0 }}>
            {getSectionLabel(section, t)}
        </StyTitle>
    );
    return (
        <StyProjectionDafHeader>
            <ConditionnalZoomIconButton disabled={!isExpanded} />
            {isFullScreen ? (
                title
            ) : (
                <StyAccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    disabled={isFullScreen}
                >
                    {title}
                </StyAccordionSummary>
            )}
        </StyProjectionDafHeader>
    );
};

export default ProjectionDafHeader;
